import React from 'react';

// كل تواريخ النشاط تُخزَّن بتوقيت UTC — نضمن تفسيرها كـUTC حتى لو جاءت بلا لاحقة
const asDate = (raw) => {
  if (!raw) return null;
  let s = String(raw);
  if (!/[zZ]$|[+-]\d{2}:?\d{2}$/.test(s)) s = `${s}Z`;
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const relativeTime = (raw) => {
  const d = asDate(raw);
  if (!d) return null;
  const mins = Math.floor((Date.now() - d.getTime()) / 60000);
  if (mins < 1) return 'الآن';
  if (mins < 60) return `قبل ${mins} دقيقة`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `قبل ${hrs} ساعة`;
  const days = Math.floor(hrs / 24);
  if (days === 1) return 'أمس';
  if (days < 30) return `قبل ${days} يوم`;
  const months = Math.floor(days / 30);
  if (months < 12) return `قبل ${months} شهر`;
  return `قبل ${Math.floor(months / 12)} سنة`;
};

export const fullDateTime = (raw) => {
  const d = asDate(raw);
  if (!d) return 'لا يوجد سجل';
  return d.toLocaleString('ar-SA-u-ca-gregory-nu-latn', { dateStyle: 'medium', timeStyle: 'short' });
};

export const dateOnly = (raw) => {
  const d = asDate(raw);
  return d ? d.toLocaleDateString('ar-SA-u-ca-gregory-nu-latn', { dateStyle: 'medium' }) : '—';
};

// نقطة حضور نابضة للمتصلين الآن
export const PresenceDot = ({ online, testId }) => (
  <span className="relative inline-flex h-2 w-2 shrink-0" data-testid={testId} title={online ? 'متصل الآن' : 'غير متصل'}>
    {online && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />}
    <span className={`relative inline-flex h-2 w-2 rounded-full ${online ? 'bg-emerald-500' : 'bg-slate-300'}`} />
  </span>
);

// خلية «آخر دخول + متصل الآن» الموحّدة في لوحة Super Admin
export const ActivityCell = ({ online, lastLogin, lastSeen, createdAt, testId, subject }) => {
  const rel = relativeTime(lastLogin);
  return (
    <div className="min-w-[132px] leading-tight" data-testid={testId}>
      <div className="flex items-center gap-1.5">
        <PresenceDot online={online} />
        <span className={`text-xs font-bold ${online ? 'text-emerald-600' : rel ? 'text-slate-700' : 'text-slate-400'}`}>
          {online ? 'متصل الآن' : rel || 'لم يسجّل دخول'}
        </span>
      </div>
      <div className="mt-0.5 text-[11px] text-slate-400" title={fullDateTime(lastLogin)}>
        {rel ? dateOnly(lastLogin) : subject || '—'}
      </div>
      {createdAt && (
        <div className="text-[11px] text-slate-400" title={fullDateTime(createdAt)}>
          منضم {relativeTime(createdAt)}
        </div>
      )}
      {!online && lastSeen && relativeTime(lastSeen) !== rel && (
        <div className="text-[11px] text-slate-400">آخر ظهور: {relativeTime(lastSeen)}</div>
      )}
    </div>
  );
};
